import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { ArrowLeft, Camera, Mail, Phone, Calendar, User, Languages } from "lucide-react"
import { Helmet } from 'react-helmet';
// import Header from "../components/Header"
import authService from '../../../Services/authService';
import SEOSchema from '../../../utils/SEOSchema';

// Sample user data - in a real app, this would come from an API or auth context
// const sampleUserData = {
//   name: "qwerty",
//   fullName: "qwerty",
//   gender: "Male",
//   dateOfBirth: "22 may 2025",
//   age: "0",
//   email: "qwerty12@gmail.com",
//   phone: "1234567890",
//   languages: "English",
//   profileImage: "",
// }

function Profile() {
  const [userData, setUserData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [userInfo, setUserInfo] = useState([])
  //const userInfo = authService.getCurrentuser();
  //alert(user);
  //console.log(user);

  // Simulate loading user data
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 500)

    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    loadProfile();
  }, []);


  const loadProfile = () => {
    const token = authService.getCurrentUsertoken();
    const url = new URL(authService.getApiUrl() + 'profile/' + authService.getCurrentuser().id);
    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
      },
    })
      .then((res) => {
        // if (res.status === 401) {
        //   authService.clientlogout();
        //   window.location.href = "/login";
        // } else {
          return res.json();
       // }
      })
      .then((result) => {
        //const data = result.data;
        // if (Array.isArray(result.data) && result.data.length > 0) {
        setUserInfo(result.data); // Store the first object
        //}
      })
      .catch((err) => {
        console.log(err.message);
      });
  };
  // Function to get initials from name
  const getInitials = (name) => {
    return name
      .split(" ")
      .map((part) => part[0])
      .join("")
      .toUpperCase()
  }

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#F5F5F7] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#951C25]"></div>
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>Profile - Vithyou</title>
        <meta name="description" content="Manage your profile and personal information on Pranaam 365." />
      </Helmet>
      
      <SEOSchema 
        type="webpage"
        data={{
          title: "Profile - Vithyou",
          description: "User profile and personal information management",
          url: window.location.href
        }}
      />
    
    <div className="min-h-screen bg-[#F5F5F7]">
      {/* Navigation */}
      {/* <Header /> */}

      <div className="max-w-6xl mx-auto px-4 py-6">
        {/* Back Button */}
        <Link to="/" className="flex items-center hover:text-[#951C25] mb-6">
          <ArrowLeft size={18} className="mr-2" />
          <span>Back to Home</span>
        </Link>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Profile Card - Left Column */}
          <div className="bg-[rgb(149,28,37,0.2)] rounded-lg p-6 flex flex-col items-center justify-center">
            <div className="relative mb-4">
              <div className="w-32 h-32 rounded-full bg-[#951C25] flex items-center justify-center text-white text-4xl font-semibold">
                {getInitials(userInfo.user_name)}
              </div>
              <button className="absolute bottom-0 right-0 w-10 h-10 rounded-full bg-red-100 text-white flex items-center justify-center">
                <Camera size={20} className="text-[#951C25]" />
              </button>
            </div>
            <h2 className="text-2xl">{userInfo.user_name}</h2>
            <p>
              {userInfo.gender}, {userInfo.age} Years
            </p>
          </div>

          {/* Personal Details - Right Column */}
          <div className="md:col-span-2 bg-white rounded-lg p-6">
            {/* Section Header */}
            <div className="mb-6">
              <h2 style={{ fontSize: "22px" }}>Personal Details</h2>
            </div>

            {/* Details Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-8">
              {/* Full Name */}
              <div className="flex items-center">
                <div className="w-10 h-10 rounded-full bg-[#F5F5F7] flex items-center justify-center mr-4">
                  <User size={20} className="text-[#757575]" />
                </div>
                <div>
                  <p>Full Name</p>
                  <p className="text-base"> {userInfo.user_name.charAt(0).toUpperCase() + userInfo.user_name.slice(1)}</p>
                </div>
              </div>

              {/* Gender */}
              <div className="flex items-center">
                <div className="w-10 h-10 rounded-full bg-[#F5F5F7] flex items-center justify-center mr-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#757575"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="8" r="7"></circle>
                    <polyline points="12 15 12 22"></polyline>
                    <line x1="8" y1="18" x2="16" y2="18"></line>
                  </svg>
                </div>
                <div>
                  <p>Gender</p>
                  <p className="text-base">{userInfo.gender.charAt(0).toUpperCase() + userInfo.gender.slice(1)}</p>
                </div>
              </div>

              {/* Date of Birth */}
              <div className="flex items-center">
                <div className="w-10 h-10 rounded-full bg-[#F5F5F7] flex items-center justify-center mr-4">
                  <Calendar size={20} className="text-[#757575]" />
                </div>
                <div>
                  <p>Age</p>
                  <p className="text-base">{userInfo.age} Years</p>
                </div>
              </div>

              {/* Contact Number */}
              <div className="flex items-center">
                <div className="w-10 h-10 rounded-full bg-[#F5F5F7] flex items-center justify-center mr-4">
                  <Phone size={20} className="text-[#757575]" />
                </div>
                <div>
                  <p>Contact Number</p>
                  <p className="text-base">{userInfo.phone_number}</p>
                </div>
              </div>
              {/* Email */}
              <div className="flex items-center">
                <div className="w-10 h-10 rounded-full bg-[#F5F5F7] flex items-center justify-center mr-4">
                  <Mail size={20} className="text-[#757575]" />
                </div>
                <div>
                  <p>Email</p>
                  <p className="text-base">{userInfo.email}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default Profile

